import { render, staticRenderFns } from "./FileConfig.vue?vue&type=template&id=d4e08d12&"
import script from "./FileConfig.vue?vue&type=script&lang=js&"
export * from "./FileConfig.vue?vue&type=script&lang=js&"
import style0 from "./FileConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports